import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BaseModalComponent} from '../base-modal.component';
import {IonInput, ModalController} from '@ionic/angular';
import {divideCurrency} from '../../_utils/currency-math';
import {FormBuilder, FormGroup} from '@angular/forms';
import {currency} from '../../_validators/currency.validator';

@Component({
    selector: 'bb-custom-dollar-amount',
    templateUrl: './custom-dollar-amount.component.html',
    styleUrls: ['./custom-dollar-amount.component.scss'],
})
export class CustomDollarAmountComponent extends BaseModalComponent implements OnInit {
    @ViewChild('manualAmount') set first(input: IonInput) {
        if (!!input) {
            setTimeout(async () => {
                await input.setFocus();
            }, 250);
        }
    }

    @Input() amount: number;
    @Input() max: number;
    @Input() label: string;
    @Input() subHeader: string;
    @Input() splitMax: number;

    formGroup: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        modalController: ModalController
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            selectedSplit: null,
            dollarAmount: [
                '',
                [currency(false, 0, this.max)]
            ]
        });
    }

    setToMax() {
        this.formGroup.controls.dollarAmount.setValue(this.max);
    }

    calculateSplit() {
        const amount = divideCurrency(this.splitMax, this.formGroup.controls.selectedSplit.value);
        this.formGroup.controls.dollarAmount.setValue(amount > this.max ? this.max : amount);
    }

    formatAndClose() {
        const value: string = this.formGroup.controls.dollarAmount.value;
        this.close(!!value && value.length > 1 && value.indexOf('$') > -1
            ? Number(value.replace(/[^0-9.-]+/g, ''))
            : value);
    }
}
